// SIWS CUSTOM: Dealer Gift Card product page — gift-card-picker.js
// Captures Dealer Name, Phone Number as line item properties.
// Min/default qty 250, step 25. Phone formatted (586) 322-6110.
// ATC stays on PDP; publishes cartUpdate.

(function () {
  var SIWS_GC_MIN  = 250;
  var SIWS_GC_STEP = 25;

  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('siws-gc-form');
    if (!form) return;

    var nameEl   = document.getElementById('siws-gc-dealer-name');
    var phoneEl  = document.getElementById('siws-gc-phone');
    var qtyEl    = document.getElementById('siws-gc-qty');
    var errorEl  = document.getElementById('siws-gc-error');
    var atcBtn   = document.getElementById('siws-gc-atc-btn');
    var variantId = parseInt(form.dataset.variantId, 10);

    // ── Formatters ──────────────────────────────────────────────

    // Phone: 10 digits → "(586) 322-6110". Leave as-is if not 10 digits
    // (lets the dealer keep an extension/notation we don't recognize).
    function formatPhone(raw) {
      var digits = String(raw || '').replace(/\D/g, '');
      if (digits.length !== 10) return String(raw || '').trim();
      return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
    }

    // Qty: round UP to next multiple of 25, floor at 250.
    function snapQty(raw) {
      var n = parseInt(raw, 10);
      if (isNaN(n) || n < SIWS_GC_MIN) return SIWS_GC_MIN;
      if (n % SIWS_GC_STEP === 0) return n;
      return Math.ceil(n / SIWS_GC_STEP) * SIWS_GC_STEP;
    }

    // ── Blur handlers ───────────────────────────────────────────

    phoneEl.addEventListener('blur', function () {
      phoneEl.value = formatPhone(phoneEl.value);
      updateAtc();
    });

    qtyEl.addEventListener('blur', function () {
      var raw = parseInt(qtyEl.value, 10);
      var snapped = snapQty(qtyEl.value);
      qtyEl.value = String(snapped);
      // Surface inline error if the dealer typed below the minimum — they
      // need to see why the value jumped.
      if (!isNaN(raw) && raw < SIWS_GC_MIN) {
        showError('Minimum order is ' + SIWS_GC_MIN + ' cards — snapped to ' + SIWS_GC_MIN + '.');
      } else {
        clearError();
      }
      updateAtc();
    });

    // Live-update ATC enable state on every keystroke in imprint fields.
    [nameEl, phoneEl, qtyEl].forEach(function (el) {
      el.addEventListener('input', updateAtc);
    });

    // ── ± stepper buttons (±25, floor 250, no max) ──────────────
    form.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-gc-step]');
      if (!btn) return;
      var direction = parseInt(btn.dataset.gcStep, 10);
      var current   = parseInt(qtyEl.value, 10);
      if (isNaN(current) || current < SIWS_GC_MIN) current = SIWS_GC_MIN;
      var next = current + (direction * SIWS_GC_STEP);
      if (next < SIWS_GC_MIN) next = SIWS_GC_MIN;
      qtyEl.value = String(next);
      clearError();
      updateAtc();
    });

    // ── Validation ──────────────────────────────────────────────

    function isValid() {
      if (!nameEl.value.trim())  return false;
      if (!phoneEl.value.trim()) return false;
      var q = parseInt(qtyEl.value, 10);
      if (isNaN(q) || q < SIWS_GC_MIN) return false;
      if (q % SIWS_GC_STEP !== 0) return false;
      return true;
    }

    function updateAtc() {
      if (isValid()) {
        atcBtn.disabled    = false;
        atcBtn.textContent = 'Add ' + qtyEl.value + ' cards to Cart';
      } else {
        atcBtn.disabled    = true;
        atcBtn.textContent = 'Complete imprint fields to continue';
      }
    }

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.setAttribute('data-visible', 'true');
    }
    function clearError() {
      errorEl.textContent = '';
      errorEl.removeAttribute('data-visible');
    }

    // ── Add to Cart ─────────────────────────────────────────────

    atcBtn.addEventListener('click', function () {
      if (atcBtn.disabled || !isValid()) return;

      // Force a final blur-format pass on phone in case the dealer clicks
      // ATC without leaving the field.
      phoneEl.value = formatPhone(phoneEl.value);
      qtyEl.value   = String(snapQty(qtyEl.value));

      var properties = {
        'Dealer Name':  nameEl.value.trim(),
        'Phone Number': phoneEl.value.trim(),
      };

      var originalText   = atcBtn.textContent;
      atcBtn.disabled    = true;
      atcBtn.textContent = 'Adding…';
      clearError();

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = {
        items: [{
          id:         variantId,
          quantity:   parseInt(qtyEl.value, 10),
          properties: properties,
        }],
        sections:     cart ? cart.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-icon-bubble'],
        sections_url: window.location.pathname,
      };

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify(body),
      })
        .then(async function (res) {
          if (!res.ok) throw new Error('Cart add failed');
          var responseData = await res.json();
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'siws-gift-card', cartData: responseData });
          }
          if (cart) {
            cart.renderContents(responseData);
          } else {
            var newBubbleHTML = responseData.sections && responseData.sections['cart-icon-bubble'];
            var liveBubble = document.getElementById('cart-icon-bubble');
            if (newBubbleHTML && liveBubble) {
              var parsed = new DOMParser().parseFromString(newBubbleHTML, 'text/html');
              var inner = parsed.querySelector('.shopify-section');
              if (inner) liveBubble.innerHTML = inner.innerHTML;
            }
          }
          atcBtn.disabled    = false;
          atcBtn.textContent = originalText;
        })
        .catch(function () {
          atcBtn.disabled    = false;
          atcBtn.textContent = originalText;
          showError('Something went wrong — please try again.');
        });
    });

    // Initial state — ATC stays disabled until imprint fields are filled.
    updateAtc();
  });
})();
